<template>
  <div>
    <p v-if="!day.entry && !addNewEntry">
      You haven't logged any entries for this day yet. Please click the button
      below to get started.
    </p>

    <a
      v-if="!addNewEntry"
      class="add-entry button button--standard"
      href="#"
      @click.prevent="addNewEntry = true"
      >Add new pacing entry</a
    >

    <form @submit.prevent="submitForm" v-if="addNewEntry">
      <div class="field">
        <label for="activity-type">
          <span>Type of physical activity/exercise</span>
          <select
            name="activity-type"
            id="activity-type"
            v-model="form.activityType"
            required
          >
            <option value="Light walking">Light walking</option>
            <option value="Brisk walking">Brisk walking</option>
            <option value="Jogging/running">Jogging/running</option>
            <option value="Cycling">Cycling</option>
            <option value="Swimming">Swimming</option>
            <option value="Dancing">Dancing</option>
            <option value="Team sport">Team sport</option>
            <option value="Stretching">Stretching</option>
            <option value="Strength training">Strength training</option>
            <option value="Climbing stairs">Climbing stairs</option>
            <option value="Grocery shopping">Grocery shopping</option>
            <option value="Housework">Housework</option>
          </select>
        </label>
      </div>

      <div class="field">
        <label for="pacing-time">
          <span>Time of activity</span>
          <input
            type="time"
            id="pacing-time"
            v-model="form.pacingTime"
            required
            @invalid="invalidTime"
          />
        </label>
      </div>

      <div class="field">
        <label for="up-time">
          <span
            >How much time can you currently do this activity safely without a
            pain flare-up?</span
          >
          <select name="up-time" id="up-time" v-model="form.upTime" required>
            <option value="0">0min</option>
            <option value="5">5min</option>
            <option value="10">10min</option>
            <option value="15">15min</option>
            <option value="30">30min</option>
            <option value="45">45min</option>
            <option value="60">60min</option>
            <option value="75">75min</option>
            <option value="90">90min</option>
          </select>
        </label>
      </div>

      <div class="field">
        <label for="down-time">
          <span
            >How much time would you need to recover safely from this
            activity?</span
          >
          <select
            name="down-time"
            id="down-time"
            v-model="form.downTime"
            required
          >
            <option value="0">0min</option>
            <option value="5">5min</option>
            <option value="10">10min</option>
            <option value="15">15min</option>
            <option value="30">30min</option>
            <option value="45">45min</option>
            <option value="60">60min</option>
            <option value="75">75min</option>
            <option value="90">90min</option>
          </select>
        </label>
      </div>

      <div class="field">
        <label for="cycles">
          <span>Number of cycles</span>
          <input
            type="number"
            name="cycles"
            id="cycles"
            v-model="form.cycles"
            min="0"
            required
          />
        </label>
      </div>

      <button type="submit" class="button button--standard">
        Log your pacing
      </button>
      <button
        class="button button--danger"
        @click.prevent="addNewEntry = false"
      >
        Cancel
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "Form",

  props: ["day", "existingEntry"],

  data() {
    return {
      addNewEntry: false,
      form: {
        activityType: "",
        pacingTime: "",
        upTime: "",
        downTime: "",
        cycles: 0,
      },
    };
  },

  methods: {
    submitForm() {
      this.addNewEntry = false;

      // Emit event to the parent to send data to Firebase.
      this.$emit("form-submit", this.form, this.day);

      // Clear form values.
      this.form = {};
    },

    invalidTime({ target }) {
      target.setCustomValidity("Please enter a valid time.");
    },
  },
};
</script>

<style scoped>
button {
  margin-right: 1rem;
}
p {
  margin-top: 0;
}
</style>
